import { computed, reactive, ref } from "vue";
import Cookies from "js-cookie";
import {
  auth_recorder,
  check_login,
  login as login_query,
  new_unknown,
  updateAuthedUser,
} from "../api/auth";
import { fetcher, updateToken } from "../api/fetcher";

function initStateModel() {
  return {
    authed: false,
    id: "",
    displayedName: "",
    avatar: "",
    tarif: "FREE",
  };
}

export const authErrorState = ref<'token-expired' | 'bad-user' | null>(null)
export function setAuthError(err: 'token-expired' | 'bad-user') {
  authErrorState.value = err;
  localStorage.removeItem('user');
  Cookies.remove('vcs-auth')
}

export const authState = reactive(initStateModel());

const savedState = initStateModel();

export async function commitAuthState() {
  if (JSON.stringify(authState) !== JSON.stringify(savedState)) {
    const res = await updateAuthedUser({
      displayedName: authState.displayedName,
      avatar: authState.avatar,
    });
    authState.avatar = res.avatar;
    authState.displayedName = res.displayedName;
    authState.id = res.id;
    authState.tarif = res.tarif;
    Object.assign(savedState, authState);
    const stored = localStorage.getItem("user");
    if (stored) {
      const user = JSON.parse(stored) as LocalStorageUser;
      user.avatar = res.avatar;
      user.displayedName = res.displayedName;
      user.id = res.id;
      user.tarif = res.tarif;
      localStorage.setItem("user", JSON.stringify(user));
    } else {
      throw "not logined";
    }
  }
}

export function isAuth() {
  return authState.authed;
}

export const tile_info = computed(() => {
  const res = {
    name: "",
    avatar: authState.avatar,
  };
  if (authState.displayedName) {
    const nf = authState.displayedName.split(" ");
    res.name += nf[0][0].toUpperCase();
    if (nf[1] && nf[1].length > 0) {
      res.name += nf[1][0].toUpperCase();
    }
  }
  return res;
});

export async function createNewUser() {
  const user = await new_unknown();
  authState.id = user.id;
  authState.displayedName = user.displayedName;
  authState.avatar = user.avatar;
  authState.tarif = user.tarif;
  const storageUser: LocalStorageUser = {
    id: user.id,
    displayedName: user.displayedName,
    avatar: user.avatar,
    token: user.token,
    tarif: user.tarif,
  };
  localStorage.setItem("user", JSON.stringify(storageUser));
  authState.authed = true;
  Object.assign(savedState, authState);
}

export async function login(token: string) {
  try {
    const user = await login_query(token);
    authState.id = user.id;
    authState.displayedName = user.displayedName;
    authState.avatar = user.avatar;
    authState.tarif = user.tarif;
    const storageUser: LocalStorageUser = {
      id: user.id,
      displayedName: user.displayedName,
      avatar: user.avatar,
      token: user.token,
      tarif: user.tarif,
    };
    localStorage.setItem("user", JSON.stringify(storageUser));
    authState.authed = true;
    Object.assign(savedState, authState);
  } catch (err) {
    console.log(err);
    throw err
  }
}

export async function setLocalLogin() {
  const str = localStorage.getItem("user");
  if (str) {
    const user = JSON.parse(str) as LocalStorageUser;
    authState.id = user.id;
    authState.displayedName = user.displayedName;
    authState.avatar = user.avatar;
    authState.tarif = user.tarif;
    updateToken(user.token);
    authState.authed = true;
    Object.assign(savedState, authState);
    await check_login()
  } else {
    throw "not local data";
  }
}

export function setLocalToken() {
  const str = localStorage.getItem("user");
  if (str) {
    const user = JSON.parse(str) as LocalStorageUser;
    if(user.token) {
      updateToken(user.token);
    }
  }
}

export async function login_recorder(creds: string, roomId: string) {
  const user = await auth_recorder(creds, roomId);
  authState.id = user.id;
  authState.displayedName = user.displayedName;
  authState.avatar = user.avatar;
  authState.tarif = user.tarif;
  const storageUser: LocalStorageUser = {
    id: user.id,
    displayedName: user.displayedName,
    avatar: user.avatar,
    token: user.token,
    tarif: user.tarif,
  };
  localStorage.setItem("user", JSON.stringify(storageUser));
  updateToken(user.token);
  authState.authed = true;
}

export async function checkCallExist() {
  const res = (await fetcher.post({
    path: "/active-room/check-exist",
    payload: {
      user_id: authState.id,
    },
  })) as { state: boolean };
  return res.state;
}

export interface LocalStorageUser {
  id: string;
  displayedName: string;
  avatar: string;
  token: string;
  tarif: string;
}
